<template>
  <div class="padbox">
    <el-row :gutter="60">
      <el-col :span="12">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-divider content-position="left">达人码锁定时长</el-divider>
            <el-form
              ref="hourTimeForm"
              :model="rulesForm"
              :rules="rules"
              class="demo-editForm"
              label-width="200px"
            >
              <el-form-item label="锁定时长(分):" prop="hourTime">
                <el-input
                  v-model="rulesForm.hourTime"
                  type="number"
                  min="0"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="submitForm('hourTimeForm')"
                  style="margin-left: 33%"
                  >提交</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>

          <!-- <el-col :span="24">
            <el-divider content-position="left">过滤订单的时间配置</el-divider>
            <el-form
              ref="orderForm"
              :model="rulesForm"
              :rules="rules"
              class="demo-editForm"
              label-width="200px"
            >
              <el-form-item label="时间:" prop="range">
                <el-date-picker
                  v-model="rulesForm.range"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm:ss"
                  style="width:100%"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="submitForm('orderForm')"
                  style="margin-left: 33%"
                  >提交</el-button
                >
              </el-form-item>
            </el-form>
          </el-col> -->

          <el-col :span="24">
            <el-divider content-position="left"
              >顺丰物流月结卡号配置</el-divider
            >
            <el-form
              ref="monthlyForm"
              :model="rulesForm"
              :rules="rules"
              class="demo-editForm"
              label-width="200px"
            >
              <el-form-item label="月结卡号:" prop="monthlyCust">
                <el-input v-model="rulesForm.monthlyCust"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="submitForm('monthlyForm')"
                  style="margin-left: 33%"
                  >提交</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-divider content-position="left">小程序分享图</el-divider>
            <el-form
              ref="shareForm"
              :model="rulesForm"
              :rules="rules"
              class="demo-editForm"
              label-width="100px"
            >
              <el-form-item label="分享图:" prop="sharePoints">
                <VploadImgFour
                  :fileData="fileData"
                  :fileSize="fileSize"
                  :fileType="fileType"
                  :limit="1"
                  :value="rulesForm.shareUrl"
                  @input="getImg"
                >
                </VploadImgFour>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="submitForm('shareForm')"
                  style="margin-bottom: 20px; float: left"
                  >提交</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import VploadImgFour from "../inc/VploadImgFour";
export default {
  name: "configuration",
  components: { VploadImgFour },
  data() {
    return {
      fileData: {
        type: 0,
        fileType: 0,
      },
      fileType: ["png", "jpg", "jpeg"],
      fileSize: 5,
      dialogVisible: false,
      rulesForm: {
        hourTime: "",
        shareUrl: [],
        range: [],
        OrderFilterId: "",
        monthlyCust: "",
        monthlyId: "",
      },
      rules: {},
    };
  },
  created() {
    this.getHourTime();
    this.getShareImage();
    this.getOrderTime();
    this.getMonthly();
  },
  methods: {
    getImg(val) {
      this.rulesForm.shareUrl = val;
    },
    getHourTime() {
      this.$axios.get("/admin/sysConfig/getHourTime", {}).then((res) => {
        this.rulesForm.hourTime = res.data;
      });
    },
    getOrderTime() {
      this.$axios.get("/admin/orderFilter/getOrderFilter", {}).then((res) => {
        this.rulesForm.OrderFilterId = res.data.id;
        if (res.data.startTime && res.data.endTime) {
          this.rulesForm.range = [res.data.startTime, res.data.endTime];
        } else {
          this.rulesForm.range = [];
        }
      });
    },
    getShareImage() {
      this.$axios.get("/admin/sysConfig/getShareUrl", {}).then((res) => {
        this.rulesForm.shareUrl = res.msg;
      });
    },
    getMonthly() {
      this.$axios.post("/admin/monthlyCust/getInfo", {}).then((res) => {
        this.rulesForm.monthlyCust = res.data.monthlyCust;
        this.rulesForm.monthlyId = res.data.id;
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName == "hourTimeForm") {
            if (
              this.rulesForm.hourTime === "" ||
              this.rulesForm.hourTime === null ||
              this.rulesForm.hourTime === undefined ||
              this.rulesForm.hourTime < 0
            ) {
              this.$message({
                message: "锁定时长不能小于0",
                type: "danger",
              });
              return false;
            }

            var obj = {
              hourTime: this.rulesForm.hourTime,
            };
            this.$axios
              .get("/admin/sysConfig/updHourTime", { params: obj })
              .then((res) => {
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success",
                });
              });
          } else if (formName == "orderForm") {
            if (
              !this.rulesForm.range === "" ||
              this.rulesForm.range.length == 0
            ) {
              this.$message({
                message: "请选择时间",
                type: "danger",
              });
              return false;
            }

            var obj = {
              id: this.rulesForm.OrderFilterId,
              startTime:
                this.rulesForm.range && this.rulesForm.range.length > 0
                  ? this.rulesForm.range[0]
                  : "",
              endTime:
                this.rulesForm.range && this.rulesForm.range.length > 1
                  ? this.rulesForm.range[1]
                  : "",
            };
            this.$axios
              .post("/admin/orderFilter/updateOrderFilter", obj)
              .then((res) => {
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success",
                });
              });
          } else if (formName == "shareForm") {
            var obj = {
              shareUrl: this.rulesForm.shareUrl,
            };
            this.$axios
              .get("/admin/sysConfig/updShareUrl", { params: obj })
              .then((res) => {
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success",
                });
              });
          } else if (formName == "monthlyForm") {
            if (
              this.rulesForm.monthlyCust === "" ||
              this.rulesForm.monthlyCust === null ||
              this.rulesForm.monthlyCust === undefined
            ) {
              this.$message({
                message: "请输入月结卡号",
                type: "danger",
              });
              return false;
            }
            this.$confirm(
              "确定输入的月结卡号正确，如错误则会影响顺丰物流的订单生成？",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "danger",
              },
            ).then(() => {
              this.$confirm("确定月结卡号正确？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "danger",
              }).then(() => {
                var obj = {
                  monthlyCust: this.rulesForm.monthlyCust,
                  id: this.rulesForm.monthlyId,
                };
                this.$axios
                  .post("/admin/monthlyCust/updateInfo", obj)
                  .then((res) => {
                    this.$message({
                      message: "恭喜你，操作成功",
                      type: "success",
                    });
                  });
              });
            });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.padbox {
  background: #fff;
  width: 100%;
  height: calc(100% - 120px);
  padding: 20px;
}
</style>
